import styled from 'styled-components';

const Wrapper = styled.section`
  .products-container {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 540px) {
    .products-container {
      gap: 1rem;
    }
  }

  @media (min-width: 768px) {
    .products-container {
      gap: 1.5rem;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1200px) {
    .products-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export default Wrapper;
